export default __webpack_public_path__ + "static/media/mode-2043.1ee5e18c.svg";